import React from 'react';

/** Lazy ClientComputedPostDetails (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedPostDetails = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-post-details' */
            './ClientComputedPostDetails'
        ),
);
